/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_DescriptionInputs */



/**
* | output |
* | --- |
* | "AWP Marine Consultancy is an experienced, independent, ISO-certified marine inspection and consultancy firm led by Master Mariners and Chief Engineers." |
*
* @param {About_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_description = /** @type {((inputs?: About_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("AWP Marine Consultancy 是一家经验丰富、独立运营、通过 ISO 认证的船舶检查与海事咨询公司，由船长和轮机长领导。")
	return /** @type {LocalizedString} */ ("AWP Marine Consultancy is an experienced, independent, ISO-certified marine inspection and consultancy firm led by Master Mariners and Chief Engineers.")
});